import styled from "styled-components";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";

export const SliderWrapper = styled.div.attrs(({ justify, bgColor, theme }) => ({
	justify: justify ? justify : "flex-start",
	bg: bgColor ? `#${bgColor}` : theme.colors.white,
}))`
	display: flex;
	flex-direction: row;

	.slider-slide,
	.slider,
	.slider-list,
	.slider-frame {
		min-height: 300px;
		outline: none;
	}
	.slider-list {
		${media.lessThan(breakpoints.mobile)`
		left: ${({ notFirstSlide }) => (notFirstSlide ? "8%" : "")};
		`}
	}

	.slider-control-bottomcenter {
		& > ul {
			flex-wrap: wrap;
			top: 0 !important;
		}
	}

	.slider-slide {
		&:before {
			content: none;
		}
	}

	.slide-current {
		& > div {
			margin-left: 0 !important;
		}
	}
	.slider-list {
		transition: height 0.2s ease;
	}
	.paging-item {
		button {
			outline: none;
			opacity: 1 !important;
			&[style] {
				fill: ${({ theme }) => theme.colors.white} !important;
			}
			svg {
				border: ${({ theme }) => `1px solid ${theme.colors.primary}`};
				border-radius: 100%;
				background-color: ${({ theme }) => theme.colors.white};
				width: 10px;
				height: 10px;
			}
		}
		&.active button[style] {
			fill: ${({ theme }) => `${theme.colors.secondary} !important`};
			svg {
				background-color: ${({ theme }) => theme.colors.secondary};
			}
		}
		&:before {
			content: none;
		}
	}

	${media.greaterThan(breakpoints.mobile)`
        flex-wrap: wrap;
        justify-content: space-between;
    `}

	${media.greaterThan(breakpoints.ipad)`
        flex-wrap: nowrap;
        & > div:first-of-type { margin-left: 0; }
    `}
    ${media.greaterThan(breakpoints.desktop)`
        justify-content: ${(props) => props.justify};
    `}
`;
